module.exports = __webpack_public_path__ + "static/media/parceiro(5).e7f8db69.png";